import { client } from '@api';
import { MERGE_CART_QUERY, MergeCartResponse, MergeCartVariables } from '@requests/cart';

import { MergedProduct } from '@types';
import { SiteConfig } from '@utils';

interface MergeCartParams {
  uid: string;
  ecomToken: string;
}

export const mergeCarts = async ({ uid, ecomToken }: MergeCartParams): Promise<MergedProduct[]> => {
  try {
    const { siteId } = SiteConfig.getConfig();
    const { wCartMergeRestore } = await client.request<MergeCartResponse, MergeCartVariables>(
      MERGE_CART_QUERY,
      { cartUid: uid, token: ecomToken, siteId },
      { authorization: `Bearer ${ecomToken}` },
    );
    return wCartMergeRestore.result.mergedProducts || [];
  } catch (error) {
    return [];
  }
};
